export const envName = 'dev';
export const environment = {
  envName: envName,

  ConnectureSSOURL: 'https://auth.nebluecloudtst.com/samlp/KZJDmwbiBnnTE9i5rz955e9TXnAHmLpX?connection=BCBSNE',
  // Litmos does not have a QA environment and auto creates users on SSO, so not adding a URL
  LitmosSSOURL: '',
  SAPUrl: 'https://sandbox.webcomserver.com/wpm/mt/bcbsneimp2',
  SoftheonSSOURL: 'https://nebraskabluetest.us.auth0.com/samlp/MpcK1GjqNmrhJZCJf6P1vy7SWfmbw03c?connection=BCBSNE',
  BavvySSOURL: 'https://auth.nebluecloudtst.com/samlp/MSoOw6MdV468id2C5fwvgfoR0XJxdk6B?connection=BCBSNE',
  BenefitFocusSSOURL: 'https://auth.nebluecloudtst.com/samlp/O8sGyXu4Z3TBYoowHn4QcCuwIoA4tqB1?connection=BCBSNE',
  WhyzenSSOURL: 'https://auth.nebluecloudtst.com/samlp/eReMRllOCoepKH0t8avbcpNmm4lEJnM3?connection=BCBSNE',
  EmpoweredMaginsSSOURL: 'https://nebraskastage.uwdatahub.com/login?q=aW5pdGlhdGUtYjJjLWxvZ2luLWJyb2tlci1wb3J0YWw=',
  EyeMedProviderURL: 'https://eyedoclocator.eyemedvisioncare.com/bcbsnecom/en-us',
  NebraskaBlueSSOURL: 'https://qa.nebraskablue.com/sso',

  production: false,
  sapDomain: 'https://sandbox.webcomserver.com/wpm/',
  redirectUrlGL:`https://employer${envName}.nebraskablue.com/`,
  redirectUrlBroker:`https://brokers${envName}.nebraskablue.com/`,
  redirectUrlIPP:`https://individual${envName}.nebraskablue.com`,
  redirectUrlSGP:`https://sgp${envName}.nebraskablue.com`,
  apiUrl: `https://employerapi${envName}.nebraskablue.com/api`,
  //redirectUrlGL: 'https://localhost:4200/',
  //redirectUrlBroker: 'https://localhost:4200/',
  //apiUrl: `http://localhost:7071/api`,
  imageUrl: `https://employersvc${envName}.nebraskablue.com/api`,

  appInsights:{
    instrumentationKey: '4ec85276-ad5c-42d0-9fd4-ce8b4c6b0175'
  },

  auth0APIDomain: 'dev-zjpan8mm2wq8ed7i.us.auth0.com',
  auth0Domain: 'auth.neblueclouddev.com',
  auth0GLclientId: 'MVrWkuxy16jC7zh6cK45DqoCoMxG6ISU',
  auth0BrokerclientId: '49syzXxSSiVxsRBYbilxZCEaZcAW1M4f',
  brokerFormId: 'ap_9xTetEnnbrz4yEmrT8eSQY',
  GLFormId: 'ap_fu83UbCQ45yRBnSVQzUZMF',

  MaintenanceMode: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error';  // Included with Angular CLI.
